export default __webpack_public_path__ + "static/media/link.ed71715d.svg";